<!--
    描述：项目一些信息的 tabs 首页
    时间：2020-05-18
    Created by ws
-->
<template>
    <div
            class="project-tabs-main w-tabs-layout"
            :class="{ 'has-header': noHeader, 'source-header': curSource !== '0' }"
    >
        <div class="project-header">
            <!-- 审计推过来的 头部 -->
            <template v-if="curSource !== '0'">
                <span class="source-title">造价分析</span>
            </template>
            <!-- 造价头部 -->
            <template v-else>{{ projectName }}</template>
        </div>

        <div class="project-difference">
            <el-tabs v-model="activeName" @tab-click="handleClick">
                <el-tab-pane label="基本信息" name="baseInfo">
                    <base-info v-if="activeName === 'baseInfo'"></base-info>
                </el-tab-pane>
                <el-tab-pane label="项目资料" name="projectData">
                    <projectData
                            v-if="activeName === 'projectData'"
                    ></projectData>
                </el-tab-pane>
                <el-tab-pane label="投资概算" name="investCalc">
                        <analysis-investment v-if="activeName === 'investCalc'"></analysis-investment>
                    </el-tab-pane>
                <el-tab-pane label="工程结构" name="structure">
                    <project-strucutre
                            v-if="activeName === 'structure'"
                    ></project-strucutre>
                </el-tab-pane>
				<!-- 项目结构新 -->
                <el-tab-pane label="项目结构" name="structureNew">
                    <project-strucutre-new
                            v-if="activeName === 'structureNew'"
                    ></project-strucutre-new>
                </el-tab-pane>
                <el-tab-pane label="造价文件" name="costFile">
                    <cost-file v-if="activeName === 'costFile'"></cost-file>
                </el-tab-pane>
                <el-tab-pane label="跟踪审计" name="audit">
                    <tracking-audit v-if="activeName === 'audit'"></tracking-audit>
                </el-tab-pane>
                <!-- 跳转页面的 tab -->
                <template v-if="noHeader">
                    <el-tab-pane label="造价总览" name="total">
                        <analysis-overview
                                v-if="activeName === 'total'"
                        ></analysis-overview>
                    </el-tab-pane>
                    <el-tab-pane label="六算分析表" name="sheet">
                        <sheet_index v-if="activeName === 'sheet'"></sheet_index>
                    </el-tab-pane>
                    <el-tab-pane label="六算分析图" name="chart">
                        <analysis-chart v-if="activeName === 'chart'"></analysis-chart>
                    </el-tab-pane>
                    <el-tab-pane label="详细分析" name="detail">
                        <analysis-detail v-if="activeName === 'detail'"></analysis-detail>
                    </el-tab-pane>
                    <el-tab-pane label="清单检查" name="inventory">
                        <analysis-inventory
                                v-if="activeName === 'inventory'"
                        ></analysis-inventory>
                    </el-tab-pane>
                    <el-tab-pane label="材价检查" name="material">
                        <analysis-material
                                v-if="activeName === 'material'"
                        ></analysis-material>
                    </el-tab-pane>
                    <el-tab-pane label="签证对比" name="visa">
                        <analysis-visa
                                v-if="activeName === 'visa'"
                        ></analysis-visa>
                    </el-tab-pane>
                    <el-tab-pane label="指标对比" name="target">
                        <analysis-target v-if="activeName === 'target'"></analysis-target>
                    </el-tab-pane>
					<!-- 指标分析新 -->
                    <el-tab-pane label="指标分析" name="targetNew">
                        <analysis-target-new v-if="activeName === 'targetNew'"></analysis-target-new>
                    </el-tab-pane>
                    <el-tab-pane label="项目文件" name="fileList">
                        <file-list v-if="activeName === 'fileList'"></file-list>
                    </el-tab-pane>
                    <el-tab-pane label="清标" name="clearSection">
                        <clear-section v-if="activeName === 'clearSection'"></clear-section>
                    </el-tab-pane>
                </template>
            </el-tabs>
        </div>
    </div>
</template>

<script>
    import baseInfo from "./base_info";
    import projectStrucutre from "./project_structure";
    import projectStrucutreNew from "./project_structure_new";
    import costFile from "./cost_file";
    import trackingAudit from "./tracking_audit";
    import analysisOverview from "@/views/cost-analysis/cost-overview/overview_index";
    import sheet_index from "@/views/cost-analysis/analysis-sheet/six_sheet_index";
    import analysisChart from "@/views/cost-analysis/analysis-chart/chart_index";
    import analysisDetail from "@/views/cost-analysis/analysis-detail/detail_index";
    import analysisInventory from "@/views/cost-analysis/analysis-inventory/inventory_index";
    import analysisMaterial from "@/views/cost-analysis/analysis-material/material_index";
    import analysisVisa from "@/views/cost-analysis/visa-detail/visa_index";
    import analysisTarget from "@/views/cost-analysis/analysis-target/target_index";
    import analysisTargetNew from "@/views/cost-analysis/analysis-target/target_index_new";
    import fileList from "@/views/cost-analysis/file-list/file_index";
    import clearSection from "@/views/cost-analysis/clear-section/clear_section_index";
    import projectData from '@/views/project-management/project-info/projectData'
    import analysisInvestment from "@/views/cost-analysis/analysis-investment/investment_index";
    export default {
        components: {
            baseInfo,
            projectStrucutre,
            projectStrucutreNew,
            costFile,
            trackingAudit,
            analysisOverview,
            analysisChart,
            analysisDetail,
            analysisInventory,
            analysisMaterial,
            analysisVisa,
            analysisTarget,
			analysisTargetNew,
            fileList,
            clearSection,
            sheet_index,
            projectData,
            analysisInvestment
        },
        data() {
            return {
                activeName: "baseInfo",
            };
        },
        created() {
            this.activeName = this.curTabName;
        },
        methods: {
            // tabs 切换
            handleClick(item) {
                // console.log(item)
                this.$router.push({
                    query: {
                        projectId: this.curProjectId,
                        source: this.curSource,
                        tabName: this.activeName,
                        noHeader: this.noHeader,
                        projectName: this.projectName,
                        userName: this.userName,
                    },
                });
            },
        },
        computed: {
            curProjectId() {
                return this.$route.query.projectId || "";
            },
            curTabName() {
                return this.$route.query.tabName || "baseInfo";
            },
            // 当前是否要头部
            noHeader() {
                return this.$route.query.noHeader;
            },
            // 项目名称
            projectName() {
                return this.$route.query.projectName || "";
            },
            // 用户名
            userName() {
                return this.$route.query.userName || "";
            },
            // 当前的 项目来源：'0' 是造价系统的， '1' 是审计系统推送的
            curSource() {
                return this.$route.query.source || "0";
            },
        },
        watch: {
            // 监听路由变化
            $route(val) {
                this.activeName = val.query.tabName
            }
        }
    };
</script>

<style scoped lang="less">
    .project-tabs-main {
        height: 100%;
        // padding: 0 10px;
        .project-difference {
            height: 100%;
        }
    }
    .has-header {
        @pdt: 48px;
        padding-top: @pdt;

        .project-header {
            position: absolute;
            top: 0;
            left: 0;
            padding: 0 20px;
            width: 100%;
            height: @pdt;
            line-height: @pdt;
            background-color: #606266;
            color: #fff;
            font-weight: 700;
            font-size: 20px;
        }
    }

    .source-header {
        @pdt: 40px;
        padding-top: @pdt;

        .project-header {
            background-color: #fff;
            border-bottom: 1px solid #8c8d8c;
            font-weight: normal;
            height: @pdt;
            line-height: @pdt;

            .source-title {
                display: inline-block;
                height: 22px;
                line-height: 24px;
                font-size: 16px;
                color: #202020;
                padding-left: 10px;
                border-left: 4px solid #38bf98;
            }
        }
    }
</style>
